export const space = {
	'1': '0.25rem',
	'2': '0.5rem',
	'3': '0.75rem',
	'4': '1rem',
	'5': '1.25rem',
	'6': '1.5rem',
	'7': '1.75rem',
	'8': '2rem',
	'9': '2.25rem',
	'10': '2.5rem',
	'12': '3rem',
	'14': '3.5rem',
	'16': '4rem',
	'18': '4.5rem',
	'20': '5rem',
	'24': '6rem',
	'32': '8rem',
	'40': '10rem',
	'48': '12rem',
	'56': '14rem',
	'64': '16rem',
	'0.5': '0.125rem',
};
